import { TableRow, Button, Layout, ClickEvent, SlideoutDecorator, DataSourceMode, SelectionType, StepEvent, Step, DataSource, TableRowDisplayEvent, Table, TableSelectionEvent, Textbox, SelectionMode, RowModeControlType } from "@mcleod/components";
import { AutogenLayoutRateAdjustmentStepper } from "./autogen/AutogenLayoutRateAdjustmentStepper";
import { ModelRow } from "@mcleod/core";
import { RateUtil } from "../RateUtil";
import { RateAdjustments } from "./RateAdjustments";

export class RateAdjustmentStepper extends AutogenLayoutRateAdjustmentStepper {
    previewButton: Button;
    saveButton: Button;

    override onLoad(): void {
        const step1 = this.stepperRateAdjustment.getComponent(1) as Step;
        const clickListenersLabel = Object.assign([], step1["_headingLabel"].getListeners("_clickListeners")?.listeners);
        for (const listener of clickListenersLabel) {
            step1["_headingLabel"].removeClickListener(listener);
        }
        const clickListenersStep = Object.assign([], step1["_stepLabel"].getListeners("_clickListeners")?.listeners);
        for (const listener of clickListenersStep) {
            step1["_stepLabel"].removeClickListener(listener);
        }
    }

    static async showAsSlideout(selectedRows: ModelRow[], sourceToSearch: DataSource) {
        const layout = Layout.getLayout("lme/dispatch/rates/RateAdjustmentStepper") as RateAdjustmentStepper;
        const previewButton = new Button({
            id: "buttonUpdateRates",
            caption: "Preview",
            onClick: async (event: ClickEvent) => {
                layout.expireOldRatesAndCopy();
            },
            backgroundColor: "primary",
            color: "primary.reverse",
            minWidth: 128,
            borderWidth: 0,
            rowBreak: false
        });

        const saveButton = new Button({
            id: "buttonSaveRates",
            caption: "Save",
            onClick: async (event: ClickEvent) => {
                await layout.saveRates();
                if (sourceToSearch) {
                    sourceToSearch.search(sourceToSearch.lastSearch)
                }
            },
            backgroundColor: "primary",
            color: "primary.reverse",
            minWidth: 128,
            borderWidth: 0,
            visible: false,
            rowBreak: false
        });
        layout.previewButton = previewButton;
        layout.saveButton = saveButton;

        return new SlideoutDecorator({
            title: "Origin/Destination Rate Adjustment",
            layout: layout,
            width: "85%",
            fillVerticalSpace: true,
            addlComponents: [previewButton, saveButton],
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                const expiredRateTable = layout.layoutRateAdjustments.tableRateAdjustments as Table;
                const editableTable = layout.layoutRateAdjustmentsStep2 as RateAdjustments
                editableTable.printable = false;
                expiredRateTable.addSelectionListener((event: TableSelectionEvent) => {
                    layout.labelSelectedCount.text = expiredRateTable.selectedRows.length.toString();
                });
                layout.sourceExpireRates.setRowsAndMode(DataSourceMode.NONE, selectedRows);
                expiredRateTable.rows.forEach((row: TableRow) => {
                    expiredRateTable.selectRow(row, SelectionType.DISTINCT, null);
                })
                editableTable.tableRateAdjustments.displaySelectCheckbox = false;
                editableTable.tableRateAdjustments.allowEdit = true;
                editableTable.tableRateAdjustments.rowModeControlType = RowModeControlType.ALWAYS_EDIT;
            }
        });
    }

    stepperAdjustmentBeforeStepListener(event: StepEvent) {
        if (event.newIndex == 1) {
            this.saveButton.visible = true;
            this.previewButton.visible = false;
        }
        else {
            this.saveButton.visible = false;
            this.previewButton.visible = true;
        }
    }

    expireOldRatesAndCopy() {
        const copiedRates = [];
        if (this.textboxNewEffectiveDate.validateSimple()) {
            this.layoutRateAdjustments.tableRateAdjustments.selectedRows.forEach((row: TableRow) => {
                const modelRow = row.data as ModelRow;
                const copiedRow = modelRow.createBasicCopy();
                const effectiveDate = new Date(this.textboxNewEffectiveDate.getBasicValue());
                copiedRow.set("effective_date", effectiveDate);
                copiedRow.set("expiration_date", null);
                copiedRow.set("id", null);
                delete copiedRow.data.minimum_charge_c
                delete copiedRow.data.minimum_charge_d
                delete copiedRow.data.minimum_charge_n
                delete copiedRow.data.minimum_charge_r
                copiedRow._appending = true;
                copiedRates.push(copiedRow);
            })
            this.sourceNewRates.setRowsAndMode(DataSourceMode.UPDATE, copiedRates);
            const nextIndex = this.stepperRateAdjustment.selectedIndex + 1;
            this.stepperRateAdjustment.selectedIndex = nextIndex;
        }
    }

   async saveRates() {
        this.saveButton.busy = true;
        await Promise.all([
            ...this.layoutRateAdjustments.tableRateAdjustments.selectedRows.map(row => {
                const modelRow = row.data as ModelRow
                const effectiveDate = new Date(this.textboxNewEffectiveDate.getBasicValue());
                effectiveDate.setDate(effectiveDate.getDate() - 1);
                modelRow.set("expiration_date", effectiveDate);
                return modelRow.post();
            }),
            ...this.sourceNewRates.data.map(row => row.post())
        ]);
        this.saveButton.busy = false;
        await this.slideOut();
    }
}
